import { render } from "./TheTie.vue?vue&type=template&id=30d7dae4&scoped=true"
import script from "./TheTie.vue?vue&type=script&lang=js"
export * from "./TheTie.vue?vue&type=script&lang=js"

import "./TheTie.vue?vue&type=style&index=0&id=30d7dae4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d7dae4"]])

export default __exports__